import React, {useEffect, useState} from 'react';
import {Button, Flex, Input, Space} from "antd";
import {BackButton, getProductSubCategoryList, getUserCities} from "../../../../shared";
import {StyledCard} from "./ProductListHeader.styled";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {RiListCheck2} from "react-icons/ri";
import {IoLocationOutline} from "react-icons/io5";
import {ProductListHeaderProps} from "../../models";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import FilterPopup from "./FilterPopup";

const ProductListHeader = ({getProductSubCategoryList,citiesId,
                               onFilterApply,getUserCities,onSearchHandle}:ProductListHeaderProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const [searchText, setSearchText] = useState<string>("")
    const [hasFilterProps, setHasFilterProps] = useState<boolean>(false)
    const location = useLocation()
    const { categoryId ,subCategoryId } = useParams();
    const subCategoryTitle = location.state.subCategoryTitle
    const navigate = useNavigate()

    const onCansel = () => {
        setOpen(false)
    }
    return (
        <StyledCard>
            <Flex vertical gap={"middle"}>
                <Flex justify={"space-between"} align={"center"} gap={"middle"}>
                    <Flex gap={"middle"} align={"center"}>
                        <BackButton/>
                        <span>{subCategoryTitle}</span>

                    </Flex>

                       <Button color={hasFilterProps ? "pink" :"default"} variant={hasFilterProps ? "filled" :"text"} onClick={() => setOpen(true)}
                               size={"small"}><RiListCheck2/>فیلتر</Button>

                </Flex>
                <Space.Compact>
                    <Input defaultValue={location.state.searchText ? location.state.searchText : ""} onChange={(e)=>setSearchText(e.target.value)}
                           onPressEnter={()=> onSearchHandle(searchText)} size={"large"}  placeholder="جستجو آگهی" />
                    <Button style={{flexDirection:"row-reverse"}} size={"large"} icon={<IoLocationOutline/>}
                            onClick={() => {
                                if (!!localStorage.getItem("jwt"))
                                navigate("/location")
                                else navigate("/login")
                            }}
                    >
                        {citiesId?.length ==0 && 'شهر'}
                        {citiesId?.length == 1 && citiesId[0]?.name}
                        {citiesId?.length > 1 && `${citiesId?.length} شهر `}
                    </Button>
                </Space.Compact>
            </Flex>
            <FilterPopup open={open} onCansel={onCansel} onFilterApply={(item : any) => {
                onFilterApply(item)
                if (item !== null) setHasFilterProps(true)
                else setHasFilterProps(false)
            }}/>

        </StyledCard>
    )

};

export default connect(null, {getProductSubCategoryList,getUserCities})(withRouter(ProductListHeader));
